export const API = import.meta.env.VITE_APP_API_PATH;
